import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Separator } from '../ui/separator';
import { Activity } from 'lucide-react';

const GridTradingCard = ({ gridData, currentPrice }) => {
  if (!gridData?.enabled) return null;

  return (
    <Card className="matrix-card rounded-none" data-testid="grid-card">
      <CardHeader className="border-b border-[#003B00] p-3">
        <CardTitle className="text-sm uppercase tracking-widest flex items-center gap-2">
          <Activity className="h-4 w-4" strokeWidth={1.5} />
          GRID TRADING
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4">
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-[#008F11] text-xs">GRID SIZE</span>
            <span className="text-[#00FF41] font-bold">
              {gridData?.size_percent || 0.05}% (${(gridData?.size_btc || 0).toFixed(2)} BTC)
            </span>
          </div>
          <Separator className="bg-[#003B00]" />
          <div className="flex justify-between items-center">
            <span className="text-[#008F11] text-xs">NEXT BUY LEVEL</span>
            <span className={`font-bold ${currentPrice <= (gridData?.next_buy || 0) ? 'text-yellow-500 animate-pulse' : 'text-[#00FF41]'}`}>
              {gridData?.next_buy > 0 ? `$${gridData.next_buy.toLocaleString()}` : 'N/A'}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-[#008F11] text-xs">NEXT SELL LEVEL</span>
            <span className={`font-bold ${currentPrice >= (gridData?.next_sell || 0) && gridData?.next_sell > 0 ? 'text-yellow-500 animate-pulse' : 'text-[#00FF41]'}`}>
              {gridData?.next_sell > 0 ? `$${gridData.next_sell.toLocaleString()}` : 'Waiting for buy...'}
            </span>
          </div>
          <Separator className="bg-[#003B00]" />
          <div className="flex justify-between items-center text-xs">
            <span className="text-[#008F11]">PENDING BUYS</span>
            <span className="text-cyan-400">{gridData?.pending_buys || 0}</span>
          </div>
          <div className="flex justify-between items-center text-xs">
            <span className="text-[#008F11]">PENDING SELLS</span>
            <span className="text-cyan-400">{gridData?.pending_sells || 0}</span>
          </div>
          {gridData?.buy_levels?.length > 0 && (
            <div className="mt-2 p-2 bg-[#001a00] rounded text-xs">
              <div className="text-[#008F11] mb-1">BUY LEVELS:</div>
              {gridData.buy_levels.map((level, i) => (
                <div key={i} className="text-cyan-400">${level.toLocaleString()}</div>
              ))}
            </div>
          )}
          <Separator className="bg-[#003B00]" />
          <div className="flex justify-between items-center text-xs">
            <span className="text-[#008F11]">REBALANCE AT</span>
            <span className="text-cyan-400">{gridData?.rebalance_percent || 1}% from base</span>
          </div>
          <div className="flex justify-between items-center text-xs">
            <span className="text-[#008F11]">DISTANCE FROM BASE</span>
            <span className={`${(gridData?.distance_from_base || 0) >= (gridData?.rebalance_percent || 1) ? 'text-yellow-500 animate-pulse' : 'text-cyan-400'}`}>
              {(gridData?.distance_from_base || 0).toFixed(3)}%
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default GridTradingCard;
